import { buildClassesHook } from '../../../../helpers/styles';

export const useClasses = buildClassesHook({
    editModal: {
        maxHeight: '90vh',
        minWidth: '600px',
    },
});
